module.exports = __webpack_public_path__ + "res/0-img_share.22b88f539867716a6dac76d169ad0cb9.png";